<template>
  <div class="home">
    <div v-if="loading">
      <app-loader />
    </div>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"/>
    <Header/>
    <template v-if="attributes_position && attributes_position == 'vertical'">
      <div class="row" style="display: inline-flex;width: 100%;">
        <div id="list-attributes">
          <Schowek/>
          <ListAttributes :fixik="posFixed"/>
        </div>
        <div id="list-products">
          <ListProducts/>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="row" style="display: block;">
        <div id="list-attributes">
          <ListAttributes :fixik="posFixed"/>
          <Schowek/>
        </div>
        <div id="list-products">
          <ListProducts :fixik="posFixed"/>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex'
import Header from './Header'
import ListAttributes from "./ListAttributes"
import ListProducts from "./ListProducts"
import Schowek from './Schowek'

export default {
  name: "HomePage",
  data() {
    return {
      posFixed: 0
    };
  },
  components: {
    Header,
    ListAttributes,
    ListProducts,
    Schowek
  },
  computed: {
    ...mapState('app', ['loading']),
    ...mapGetters('products', ['attributes_position']),
  },
  methods: {
    handleScroll (event) {
      // console.log(window.scrollY)
      this.posFixed = window.scrollY
      // if (window.scrollY > 68) {
      //   this.posFixed = true
      // } else {
      //   this.posFixed = false
      // }
      // console.log(event.body.scrollTop)
      // Any code to be executed when the window is scrolled
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
    // this.$store.dispatch("app/set_locale", this.$i18n.locale);
  },
  unmounted () {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style scoped>
  h1,
  h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .compFixed {
    position: fixed;
    top:0px;
  }
  #list-attributes {
    min-width: 410px;
  }

  .content {
    display: flex;
  }

  .menu {
    width: 475px;
    max-width: 475px;
  }
  .ListAttributes {
    padding: 10px;
  }

  .nav_categories {
    height: 20px;
  }

  article {
    width: 100%;
  }
  .Schowek {
    border: none;
  }

  .Products {
    padding: 10px;
  }

  .information {
    flex-grow: 1;
  }
  div.vue-back-to-top button.md-button {
    min-width: 50px;
  }

</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue